<template>
    <div class="noMoreData-pullText" v-if="hasMoreData">{{pullText}}</div>
    <div class="noMoreDat-list" v-else>
      <p class="noMoreData-border jrm-border-1px jrm-border-bottom"></p>
      <p class="noMoreData-textStyle">{{moreText}}</p>
      <p class="noMoreData-border jrm-border-1px jrm-border-bottom"></p>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'NoMoreData',
  props: {
    moreText: {
      type: String,
      default: '没有更多了'
    },
    pullText: {
      type: String,
      default: '上拉加载更多...'
    },
    hasMoreData: {
      type: Boolean,
      default: true
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>
<style lang="scss">
@import './../scss/mixin.scss';
.noMoreDat-list {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: $rem70;
}
.noMoreData-border {
  width: $rem40;
}
.noMoreData-textStyle {
  font-family: PingFangSC-Regular;
  font-size: $rem24;
  color: #c2c2c2;
  letter-spacing: 0;
  line-height: $rem70;
  text-align: center;
  margin-left: $rem16;
  margin-right: $rem16;
}
.noMoreData-pullText {
  font-family: PingFangSC-Regular;
  font-size: $rem24;
  color: #c2c2c2;
  letter-spacing: 0;
  line-height: $rem70;
  text-align: center;
  width: 100%;
}
</style>
